<template>
  <div class="transaction_detail">
    <ModalDelete ref="ModalDelete" confirm-text="ya" @action="cancel">
      <template v-slot:title>
        <span class="black--text text-capitalize font-weight-bold"
          >Batalkan Transaksi</span
        >
      </template>
      <template v-slot:body>
        <div class="text-center pt-3">
          Apakah Anda yakin untuk membatalkan transaksi "
          <span class="text-capitalize">{{
            detailTransaction.trx_midtrans_invoice
          }}</span
          >"?
        </div>
      </template>
    </ModalDelete>
    <ModalDelete
      ref="ModalReceive"
      confirm-text="ya"
      confirm-color="black"
      @action="receive"
    >
      <template v-slot:title>
        <span class="black--text--text text-capitalize font-weight-bold"
          >konfirmasi penerimaan</span
        >
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin sudah menerima transaksi ini?
        </div>
      </template>
    </ModalDelete>
    <modalPayment
      ref="modalPayment"
      v-if="detailTransaction.trx_payment_method == 'bank_transfer'"
      @action="confirmTransfer"
    ></modalPayment>
    <modalHistoryTermin
      ref="modalHistory"
      v-if="detailTransaction.is_top == '1'"
    ></modalHistoryTermin>
    <v-col class="pt-5">
      <div>
        <v-row>
          <v-col cols="12" md="3" class="py-0 pr-md-0">
            <profile-menu></profile-menu>
          </v-col>
          <v-col cols="12" md="9" class="pl-md-5 py-0 mt-5 mt-md-0">
            <div>
              <v-row>
                <v-col cols="12" md="6" class="py-0">
                  <v-card outlined elevation="0" class="pt-3 pb-5 rounded-lg">
                    <v-row class="px-3">
                      <v-col class="py-2 text-body-2 my-auto">
                        <span class="font-weight-bold">Data Pembelian</span>
                      </v-col>
                    </v-row>
                    <div class="px-3 py-2">
                      <v-divider></v-divider>
                    </div>
                    <v-row class="px-3">
                      <v-col class="pb-0 text-body-2">
                        <v-card outlined class="rounded-lg">
                          <v-row class="px-3">
                            <v-col md="5" class="py-2">
                              <div
                                class="font-size-13 grey--text text--darken-1"
                              >
                                No Transaksi
                              </div>
                              <div class="pt-1 text-body-2 font-weight-bold">
                                {{ detailTransaction.trx_code }}
                              </div>
                            </v-col>
                            <v-col md="7" class="py-2">
                              <div
                                class="font-size-13 grey--text text--darken-1"
                              >
                                Nama Store
                              </div>
                              <div class="pt-1 text-body-2 font-weight-bold">
                                {{ detailTransaction.trx_store_name }}
                              </div>
                            </v-col>
                            <v-col md="4" class="py-2 my-auto" v-if="false">
                              <v-btn
                                text
                                color="primary"
                                class="text-body-2 font-weight-bold text-capitalize"
                                >Kirim Pesan</v-btn
                              >
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                    <v-row
                      class="px-3 pt-3"
                      v-for="(item, i) in detailTransaction.trx_detail"
                      :key="i"
                    >
                      <v-col lg="3" class="py-0">
                        <v-card outlined>
                          <div class="pa-1">
                            <v-img
                              class="rounded-lg mx-auto"
                              width="60"
                              height="60"
                              :src="
                                item.trx_detail_product_image[0]
                                  ? item.trx_detail_product_image[0]
                                  : '/assets/product/default.png'
                              "
                            ></v-img>
                          </div>
                        </v-card>
                      </v-col>
                      <v-col lg="5" class="py-0 pl-0">
                        <div class="font-size-13">
                          {{ item.trx_detail_product_name }}
                        </div>
                        <div class="font-size-10 grey--text text--darken-1">
                          Jumlah : {{ item.trx_detail_quantity | toNumber }}
                        </div>
                        <div class="font-size-10 grey--text text--darken-1">
                          Berat : {{ item.trx_detail_product_weight | toKg }}
                        </div>
                        <div
                          class="font-size-10 grey--text text--darken-1"
                          v-if="item.trx_detail_product_pv > 0"
                        >
                          PV
                          <span
                            :class="
                              item.trx_detail_product_internal_type == 'ro'
                                ? 'text-uppercase'
                                : 'text-capitalize'
                            "
                            >{{
                              {
                                type: item.trx_detail_product_internal_type,
                                register: detailTransaction.trx_is_register,
                              } | internalType
                            }}</span
                          >
                          :
                          {{
                            (item.trx_detail_product_pv *
                              item.trx_detail_quantity)
                              | toNumber
                          }}
                        </div>
                        <div
                          class="font-size-10"
                          v-if="item.trx_detail_is_nego"
                        >
                          <template
                            v-if="['1', '2'].includes(item.trx_detail_is_nego)"
                          >
                            <span
                              v-if="detailTransaction.trx_status_nego == '1'"
                              >Harga Nego Diajukan: <br />
                              {{ item.trx_detail_price_nego | toRupiah }}
                            </span>
                            <br />
                            Status Nego:
                            <v-chip
                              v-if="item.trx_detail_status_nego == 'approved'"
                              class="ma-1"
                              color="green"
                              outlined
                            >
                              <small>Disetujui</small>
                            </v-chip>
                            <v-chip
                              v-if="item.trx_detail_status_nego == 'rejected'"
                              class="ma-1"
                              color="red"
                              outlined
                            >
                              <small>Ditolak</small>
                            </v-chip>
                            <v-chip
                              v-if="item.trx_detail_status_nego == 'submitted'"
                              class="ma-1"
                              color="orange"
                              outlined
                            >
                              <small
                                v-if="item.trx_detail_nego_is_member == '1'"
                                >Perlu Ditinjau Seller</small
                              >
                              <small
                                v-if="item.trx_detail_nego_is_seller == '1'"
                                >Perlu Ditinjau Buyer</small
                              >
                            </v-chip>
                          </template>
                        </div>
                      </v-col>
                      <v-col lg="4" class="py-0 pl-0 my-auto text-right">
                        <div class="text-body-2 font-weight-bold">
                          {{
                            (item.trx_detail_product_price *
                              item.trx_detail_quantity)
                              | toRupiah
                          }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-row class="px-3">
                      <v-col
                        class="py-0 text-body-2"
                        v-if="detailTransaction.store"
                      >
                        <div class="pt-4 d-flex">
                          <div
                            class="pr-5"
                            v-if="detailTransaction.trx_pv_total_aktivasi > 0"
                          >
                            <div class="font-size-13 grey--text text--darken-1">
                              Total PV Aktivasi
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{ detailTransaction.trx_pv_total_aktivasi }}
                            </div>
                          </div>
                          <div
                            :class="
                              detailTransaction.trx_pv_total_aktivasi > 0
                                ? 'pl-5'
                                : 'pr-5'
                            "
                            v-if="detailTransaction.trx_pv_total_ro > 0"
                          >
                            <div class="font-size-13 grey--text text--darken-1">
                              Total PV RO
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{ detailTransaction.trx_pv_total_ro }}
                            </div>
                          </div>
                        </div>
                        <div class="pt-3">
                          <div class="font-size-13 grey--text text--darken-1">
                            Status Pembelian
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{
                              detailTransaction.trx_status | toStatusTransaction
                            }}
                          </div>
                        </div>
                        <div class="pt-3">
                          <div class="font-size-13 grey--text text--darken-1">
                            Penjual
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{ detailTransaction.store.user_name }}
                          </div>
                        </div>
                        <div
                          class="pt-4"
                          v-if="
                            detailTransaction.trx_shipping_method == 'courier'
                          "
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Alamat Pengiriman
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{ addressText(detailTransaction.trx_address) }}
                          </div>
                        </div>
                        <div
                          class="pt-4 d-flex"
                          v-if="
                            detailTransaction.trx_shipping_method == 'pick_up'
                          "
                        >
                          <div class="pr-5">
                            <div class="font-size-13 grey--text text--darken-1">
                              Metode Pengambilan
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              Ambil Di Toko
                            </div>
                          </div>
                          <div class=" pl-5">
                            <div class="font-size-13 grey--text text--darken-1">
                              Tanggal Pengambilan
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{ detailTransaction.trx_pick_up_date | tanggal }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="pt-4"
                          v-if="
                            detailTransaction.trx_shipping_method == 'pick_up'
                          "
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Alamat Pengambilan
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{ addressTextStore(detailTransaction.store) }}
                          </div>
                        </div>
                        <div
                          class="pt-4 d-flex"
                          v-if="
                            ['courier','store_courier'].includes(detailTransaction.trx_shipping_method)
                          "
                        >
                          <div class="pr-5">
                            <div class="font-size-13 grey--text text--darken-1">
                              Jasa Pengiriman
                            </div>
                            <div  v-if="
                            detailTransaction.trx_shipping_method == 'courier'
                          " class="pt-1 text-body-2 font-weight-bold">
                              <span  class="text-uppercase">{{
                                detailTransaction.trx_courier_code
                              }}</span>
                              <span
                                >({{
                                  detailTransaction.trx_courier_service
                                }})</span
                              >
                            </div>
                            <div  v-if="
                            detailTransaction.trx_shipping_method == 'store_courier'
                          " class="pt-1 text-body-2 font-weight-bold">
                              <span
                                > {{
                                  detailTransaction.trx_courier_service
                                }} </span
                              >
                            </div>
                          </div>
                          <div class="pl-5"  v-if="
                            ['courier'].includes(detailTransaction.trx_shipping_method)
                          ">
                            <div class="font-size-13 grey--text text--darken-1">
                              No Resi
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{ detailTransaction.trx_courier_resi }}
                            </div>
                            <v-btn
                              v-show="
                                detailTransaction.trx_courier_resi != null &&
                                detailTransaction.trx_agregator == 'kiriminaja'
                                  ? true
                                  : false
                              "
                              outlined
                              dark
                              color="grey"
                              :class="{ 'v-btn--block': isMobile }"
                              @click="lacakStatusPesanan = true"
                            >
                              <v-icon>mdi-truck</v-icon>
                              <span
                                class="text-subtitle-2 text-capitalize font-weight-bold"
                                :class="{ 'ml-2': !isMobile }"
                                >Lacak Pesanan</span
                              >
                            </v-btn>
                          </div>
                          <div class="pl-5"  v-if="
                            ['store_courier'].includes(detailTransaction.trx_shipping_method)
                          ">
                            <div class="font-size-13 grey--text text--darken-1">
                             Biaya Kirim
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{
                                detailTransaction.trx_price_shipping | toRupiah
                              }}
                            </div> 
                          </div>
                        </div>
                        <div
                          class="pt-4 d-flex"
                          v-if="
                            detailTransaction.trx_shipping_method == 'courier'
                          "
                        >
                          <div class="pr-5">
                            <div class="font-size-13 grey--text text--darken-1">
                              Estimasi Barang Sampai
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{
                                detailTransaction.trx_courier_etd
                                  ? detailTransaction.trx_courier_etd
                                  : "-"
                              }}
                            </div>
                          </div>
                          <div class="pl-5">
                            <div class="font-size-13 grey--text text--darken-1">
                              Biaya Kirim
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{
                                detailTransaction.trx_price_shipping | toRupiah
                              }}
                            </div>
                          </div>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
                <v-col cols="12" md="6" class="mt-5 mt-md-0 py-0">
                  <v-card outlined elevation="0" class="py-3 rounded-lg">
                    <v-row class="px-3">
                      <v-col col="12" class="py-2 text-body-2 my-auto">
                        <span>No Tagihan</span>
                        <span class="pl-2 font-weight-bold">{{
                          detailTransaction.trx_midtrans_invoice
                        }}</span>
                      </v-col>
                      <!-- <v-col class="py-2 text-body-2 my-auto text-right">
												<span class="text-capitalize text-body-2 font-weight-bold red--text">Batalkan Transaksi</span>
                      </v-col>-->
                    </v-row>
                    <div class="px-3 py-2">
                      <v-divider></v-divider>
                    </div>
                    <v-row class="px-3">
                      <v-col md="12" class="py-0 text-body-2">
                        <div
                          class="pt-3"
                          v-if="detailTransaction.trx_status == 'created'"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Batas Pembayaran
                          </div>
                          <div
                            class="pt-1 text-body-2 font-weight-bold red--text"
                          >
                            {{
                              detailTransaction.trx_limit_confirmation_created
                                | tanggaljam
                            }}
                          </div>
                        </div>
                        <div
                          class="pt-3"
                          v-if="detailTransaction.trx_status == 'paid'"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Batas Proses
                          </div>
                          <div
                            class="pt-1 text-body-2 font-weight-bold red--text"
                          >
                            Penjual harus memproses pesananmu sebelum
                            {{
                              detailTransaction.trx_limit_confirmation_paid
                                | haritanggaljam
                            }}
                          </div>
                        </div>
                        <div
                          class="pt-3"
                          v-if="detailTransaction.trx_status == 'processed'"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Batas Kirim
                          </div>
                          <div
                            class="pt-1 text-body-2 font-weight-bold red--text"
                          >
                            Penjual harus mengirim pesananmu sebelum
                            {{
                              detailTransaction.trx_limit_confirmation_processed
                                | haritanggaljam
                            }}
                          </div>
                        </div>
                        <div
                          class="pt-3"
                          v-if="detailTransaction.is_top !== '1'"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Status Tagihan
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{
                              detailTransaction.trx_midtrans_status
                                | toStatusMidtrans
                            }}
                            <div
                              v-if="detailTransaction.trx_status == 'pending'"
                              class="pt-1 text-body-2 font-weight-bold red--text"
                            >
                              <small>
                                <i>Menunggu Konfirmasi Admin</i>
                              </small>
                            </div>
                          </div>
                        </div>
                        <div
                          class="pt-3"
                          v-if="detailTransaction.is_top == '1'"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Status Tagihan
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{
                              detailTransaction.payment_status === null ? 'pending' : detailTransaction.payment_status | toStatusTempo
                            }}
                            <div
                              v-if="detailTransaction.trx_status == 'pending'"
                              class="pt-1 text-body-2 font-weight-bold red--text"
                            >
                              <small>
                                <i>Menunggu Konfirmasi Admin</i>
                              </small>
                            </div>
                          </div>
                        </div>
                        <div class="pt-4">
                          <div class="font-size-13 grey--text text--darken-1">
                            Metode Pembayaran
                          </div>
                          <div
                            v-if="
                              detailTransaction.trx_payment_method ==
                              'full_coin_gen'
                            "
                            class="pt-1 text-body-2 font-weight-bold"
                          >
                            Coin Gen
                          </div>
                          <div
                            v-if="
                              detailTransaction.trx_payment_method !=
                                'full_coin_gen' &&
                              detailTransaction.trx_payment_text
                            "
                            class="pt-1 text-body-2 font-weight-bold"
                          >
                            {{
                              detailTransaction.trx_payment_text.payment_text
                            }}
                          </div>
                          <div
                            v-if="
                              detailTransaction.trx_payment_method !=
                                'full_coin_gen' &&
                              detailTransaction.trx_payment_text
                            "
                          >
                            <v-img
                              width="85"
                              :src="
                                detailTransaction.trx_payment_text.payment_image
                              "
                            ></v-img>
                          </div>
                          <div
                            v-if="
                              detailTransaction.trx_payment_text &&
                              detailTransaction.trx_payment_method ==
                                'bank_transfer'
                            "
                            class="pt-1 text-body-2"
                          >
                            {{
                              detailTransaction.trx_payment_data
                                .trx_payment_bank_to_bank_account_number
                            }}
                          </div>
                          <div
                            v-if="
                              detailTransaction.trx_payment_text &&
                              detailTransaction.trx_payment_method ==
                                'bank_transfer'
                            "
                            class="pt-1 text-body-2"
                          >
                            {{
                              detailTransaction.trx_payment_data
                                .trx_payment_bank_to_bank_account_name
                            }}
                          </div>
                          <div
                            v-if="
                              detailTransaction.trx_payment_text &&
                              ['midtrans', 'va'].includes(
                                detailTransaction.trx_payment_method
                              )
                            "
                            class="pt-1 text-body-2"
                          >
                            {{ detailTransaction.trx_midtrans_payment_code }}
                          </div>
                          <div
                            v-if="
                              detailTransaction.is_top == '1' &&
                              detailTransaction.payment_status !== 'paid'
                            "
                            class="pt-4 text-body-2"
                          >
                            <div class="font-size-13 grey--text">
                              Pembayaran Termin
                            </div>
                            <span class="red--text font-weight-bold"
                              >Jatuh Tempo :
                              {{
                                detailTransaction.termin_date | tanggal
                              }}</span
                            >
                          </div>
                        </div>
                        <div
                          class="pt-4"
                          v-if="detailTransaction.trx_subtraction_coin_gen > 0"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Total Belanja
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{ detailTransaction.trx_bill | toRupiah }}
                          </div>
                        </div>
                        <div
                          class="pt-4"
                          v-if="detailTransaction.trx_subtraction_coin_gen > 0"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Coin Gen
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            -
                            {{
                              detailTransaction.trx_subtraction_coin_gen
                                | toRupiah
                            }}
                          </div>
                        </div>
                        <div
                          class="pt-4"
                          v-if="detailTransaction.trx_price_grand_total > 0"
                        >
                          <div class="font-size-13 grey--text text--darken-1">
                            Total Tagihan
                          </div>
                          <div class="pt-1 text-body-2 font-weight-bold">
                            {{
                              detailTransaction.trx_price_grand_total | toRupiah
                            }}
                          </div>
                        </div>
                        <template  v-if="
                              detailTransaction.is_top == '1' &&
                              detailTransaction.payment_status !== 'paid'
                            ">
                          <div class="pt-4" >
                            <div class="font-size-13 grey--text text--darken-1">
                              Tagihan Dibayarkan  
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold">
                              {{
                                detailTransaction.payment_finance_amount | toRupiah
                              }}
                            </div>
                          </div>
                          <div class="pt-4" >
                            <div class="font-size-13 grey--text text--darken-1">
                              Sisa Tagihan  
                            </div>
                            <div class="pt-1 text-body-2 font-weight-bold red--text">
                              {{
                              detailTransaction.payment_finance_amount == 0 ? detailTransaction.trx_price_grand_total :  detailTransaction.payment_remaining_debt | toRupiah
                              }}
                            </div>
                          </div>

                        </template>
                      </v-col>
                    </v-row>
                    <div class="pt-3">
                      <v-col md="12" class="pb-0">
                        <v-btn
                          outlined
                          height="45"
                          block
                          color="#272727"
                          class="rounded-lg"
                          @click="
                            printInvoice(detailTransaction.trx_midtrans_invoice)
                          "
                        >
                          <div class="font-weight-bold text-body-2 d-flex">
                            <v-icon>mdi-printer</v-icon>
                            <div class="pl-2 my-auto">Cetak Invoice</div>
                          </div>
                        </v-btn>
                      </v-col>
                    </div>
                    <div
                      class="pt-3"
                      v-if="
                        detailTransaction.trx_status == 'on_delivery' &&
                        loadTransaction == false
                      "
                    >
                      <v-col md="12" class="pb-0">
                        <v-btn
                          height="45"
                          block
                          color="#272727"
                          class="rounded-lg"
                          @click="confirmReceived"
                        >
                          <div class="font-weight-bold text-body-2 d-flex">
                            <div
                              class="text-capitalize font-weight-bold rounded-lg white--text"
                            >
                              Konfirmasi Penerimaan
                            </div>
                          </div>
                        </v-btn>
                      </v-col>
                    </div>
                 <template v-if="detailTransaction.trx_status !== 'cancel'">
                  <v-row
                      class="px-3 justify-center"
                      v-if="detailTransaction.trx_status == 'created'"
                    >
                      <template v-if="detailTransaction.trx_is_nego !== '1'">
                          <v-col
                            class="pr-md-1 pb-0"
                            v-if="
                              detailTransaction.trx_payment_method == 'midtrans'
                            "
                          >
                            <v-btn
                              depressed
                              height="45"
                              block
                              class="rounded-lg btn-primary"
                              @click="
                                downloadPDF(detailTransaction.trx_pdf_url)
                              "
                              v-if="detailTransaction.trx_pdf_url"
                            >
                              <div
                                class="font-weight-bold text-body-2 white--text"
                              >
                                Cara Pembayaran
                              </div>
                            </v-btn>
                          </v-col>
                      </template>
                    </v-row>
                    <v-row class="px-3 justify-center" v-if="detailTransaction.trx_is_nego == '1'" >
                      <!-- transaksi nego == 1 -->
                      <v-col>
                        <v-btn
                          outlined
                          height="45"
                          block color="#2196F3"
                          class="rounded-lg  "
                          target="_blank"
                          :to="
                            '/nego-history-transaction?code=' + detailTransaction.trx_code
                          "
                        >
                          <div
                            class="font-weight-bold text-body-2 d-flex  "
                          >
                            <v-icon>mdi-clipboard-check</v-icon>
                            <div class="pl-2 my-auto">Riwayat Nego Barang</div>
                          </div>
                        </v-btn>
                      </v-col>
                      <template v-if="detailTransaction.trx_status_nego !== '2'">
                        <!-- status nego blm final -->
                        <v-col>
                          <v-btn
                            depressed
                            height="45"
                            block
                            class="rounded-lg btn-primary"
                            @click="statusNego"
                          >
                            <div
                              class="font-weight-bold text-body-2 d-flex  "
                            >
                              <!-- <v-icon>mdi-account-cash</v-icon> -->
                               <v-img src="/assets/icons/nego.svg"></v-img>
                              <div class="pl-2 my-auto">Status Nego</div>
                            </div>
                          </v-btn>
                        </v-col>
                      </template>
                    </v-row>
                    <template v-if="detailTransaction.is_top == '1' && ['0','2'].includes(detailTransaction.trx_status_nego)">
                      <v-row class="px-3 justify-center" >
                        <!-- transaksi tempo == 1 -->
                        <v-col class="pr-md-1 pb-0">
                          <v-btn
                            outlined
                            height="45"
                            block
                            color="orange"
                            class="rounded-lg btn-error-outline"
                            @click="buktiTop"
                          >
                            <div class="font-weight-bold text-body-2 d-flex">
                              <v-icon>mdi-clipboard-text</v-icon>
                              <div class="pl-2 my-auto">Riwayat Upload Pembayaran</div>
                            </div>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-if="detailTransaction.trx_status !== 'expired'">
                      <v-row class="px-3 justify-center" v-if="showButtonUploadPayment">
                      <!-- v-if="
                                         ((detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2') && detailTransaction.is_top !== '1' && detailTransaction.trx_status !== 'paid' ) ||
                      ((detailTransaction.is_top == '1' && detailTransaction.payment_status !== 'paid') && detailTransaction.trx_is_nego !== '1') ||
                      (detailTransaction.is_top == '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2' &&  detailTransaction.payment_status !== 'paid' ) ||
                      (detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_payment_method =='bank_transfer' && detailTransaction.trx_status_nego == '2')||
                       (detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego !== '1' && detailTransaction.trx_payment_method =='bank_transfer') && detailTransaction.trx_status !== 'paid' ||
                       (detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2' )
                      " -->
                      <!-- {{((detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2') && detailTransaction.is_top !== '1' && detailTransaction.trx_status !== 'paid' )}}
                      {{((detailTransaction.is_top == '1' && detailTransaction.payment_status !== 'paid') && detailTransaction.trx_is_nego !== '1')}}
                      {{(detailTransaction.is_top == '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2' &&  detailTransaction.payment_status !== 'paid' ) }}
                      {{(detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_payment_method =='bank_transfer' && detailTransaction.trx_status_nego == '2')  }}
                       {{(detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego !== '1' && detailTransaction.trx_payment_method =='bank_transfer') && detailTransaction.trx_status !== 'paid' }}
                       {{(detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego == '1' ** detailTransaction.trx_status_nego == '2' ) }} -->
                        <v-col
                            class="pr-md-1 pb-0"
                          >
                            <v-btn
                              depressed
                              height="45"
                              block
                              class="rounded-lg btn-primary"
                              @click="uploadPayment"
                            >
                              <div
                                class="font-weight-bold text-body-2 d-flex white--text"
                              >
                                <v-icon>mdi-upload</v-icon>
                                <div class="pl-2 my-auto">Bukti Pembayaran</div>
                              </div>
                            </v-btn>
                          </v-col>
                      </v-row>
                      <v-row class="px-3 justify-center" v-if="detailTransaction.trx_status == 'created'">
                        <v-col>
                          <v-btn
                            @click="$refs.ModalDelete.modalShow()"
                            outlined
                            height="45"
                            block
                            color="red"
                            class="rounded-lg btn-error-outline"
                          >
                            <div class="font-weight-bold text-body-2">
                              Batalkan Transaksi
                            </div>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </template>
                 </template>
                 <template v-else>
                   <v-row class="px-3 justify-center">
                    <v-col v-if="detailTransaction.trx_is_nego == '1'">
                        <v-btn
                          depressed
                          height="45"
                          block
                          class="rounded-lg btn-primary-outline"
                          target="_blank"
                          :to="
                            '/nego-history-transaction?code=' + detailTransaction.trx_code
                          "
                        >
                          <div
                            class="font-weight-bold text-body-2 d-flex  "
                          >
                            <v-icon>mdi-clipboard-text</v-icon>
                            <div class="pl-2 my-auto">Riwayat Nego Barang</div>
                          </div>
                        </v-btn>
                      </v-col>
                      <v-col v-if="detailTransaction.is_top == '1'" class="pr-md-1 pb-0">
                          <v-btn
                            outlined
                            height="45"
                            block
                            color="orange"
                            class="rounded-lg btn-error-outline"
                            @click="buktiTop"
                          >
                            <div class="font-weight-bold text-body-2 d-flex">
                              <v-icon>mdi-clipboard-text</v-icon>
                              <div class="pl-2 my-auto">Riwayat Upload Pembayaran</div>
                            </div>
                          </v-btn>
                        </v-col>
                    </v-row>
                 </template>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-col>
    <modal-nego
      v-model="nego"
      :data="formNego"
      @updateData="getDetail"
      :trx_id="detailTransaction.trx_id"
    />

    <v-dialog v-model="lacakStatusPesanan" persistent max-width="600">
      <v-card>
        <v-card-title
          class="text-h6 text-h6 text-capitalize black--text darken-4"
        >
          <v-icon>mdi-truck</v-icon>&nbsp;Lacak Pesanan
        </v-card-title>
        <v-card-text class="py-0 px-5">
          <!-- {{historyTrackingData}} -->
          <template v-if="detailTransaction">
            <v-row class="px-5 py-3 align-center">
              <v-col cols="12" sm="6">
                <div
                  class="d-block text-subtitle-1 font-weight-bold black--text"
                >
                  {{ detailTransaction.trx_code }}
                </div>
                <div class="text-subtitle-2">
                  {{
                    formatDateText(
                      detailTransaction.trx_status_created_datetime,
                      "DD MMMM YYYY HH:mm"
                    )
                  }}
                </div>
                <div class="text-subtitle-2">
                  Kurir: {{ detailTransaction.trx_courier_code }}
                </div>
                <div class="text-subtitle-2">
                  Resi: {{ detailTransaction.trx_courier_resi }}
                </div>
              </v-col>

              <v-col
                cols="12"
                sm="6"
                :class="isMobile ? 'text-left pt-0' : 'text-right'"
              >
                <v-chip
                  v-if="detailTransaction.trx_status == 'completed'"
                  label
                  :class="colorStatus(detailTransaction.trx_status)"
                  >{{ statusCaption(detailTransaction.trx_status) }}</v-chip
                >
                <v-chip
                  v-else-if="detailTransaction.delivery_status == '1'"
                  label
                  :class="colorStatus('completed')"
                  >Telah Diterima</v-chip
                >
                <template v-else-if="historyTrackingData.length">
                  <v-chip
                    label
                    class="font-weight-bold"
                    :class="colorStatus('on_delivery')"
                    v-if="
                      detailTransaction.trx_status == 'pickup' &&
                      detailTransaction.is_drop == '0'
                    "
                    >{{ "Menunggu Pickup" }}
                  </v-chip>
                  <v-chip
                    label
                    class="font-weight-bold"
                    :class="colorStatus('on_delivery')"
                    v-else-if="
                      detailTransaction.trx_status == 'pickup' &&
                      detailTransaction.is_drop == '1'
                    "
                    >{{ "Menunggu Diantar" }}
                  </v-chip>
                  <v-chip
                    label
                    class="font-weight-bold"
                    :class="colorStatus('on_delivery')"
                    v-else
                    >{{ statusCaption(detailTransaction.trx_status) }}
                  </v-chip>
                </template>

                <v-chip
                  v-else
                  label
                  :class="colorStatus(detailTransaction.trx_status)"
                  >{{ statusCaption(detailTransaction.trx_status) }}</v-chip
                >
              </v-col>
            </v-row>
            <v-spacer></v-spacer>
            <hr />

            <div class="d-block py-5">
              <v-timeline align-top dense v-if="historyTrackingData.length">
                <template v-for="(log, idl) in historyTrackingData">
                  <v-timeline-item
                    :color="idl == 0 ? 'green' : 'grey darken-5'"
                    small
                    :key="idl"
                    v-if="log.manifest_datetime"
                  >
                    <v-row class="py-0">
                      <v-col cols="12" sm="4" class="py-0">
                        <span class="grey--text">{{
                          formatDateText(
                            log.manifest_datetime,
                            "DD MMMM YYYY HH:mm"
                          )
                        }}</span>
                      </v-col>
                      <v-col class="py-0">
                        <div
                          class="d-block font-weight-bold black--text"
                          :class="{ 'text-subtitle-2': isMobile }"
                        >
                          {{ log.manifest_description }}
                          <br />
                          <span class="grey--text">{{ log.city_name }}</span>
                          <template
                            v-if="
                              detailTransaction.delivery_status == '1' &&
                              idl == 0
                            "
                          >
                            <br />
                            <span class="grey--text"
                              >DELIVERY :
                              {{ detailTransaction.delivery_receiver }}</span
                            >
                          </template>
                        </div>
                      </v-col>
                    </v-row>
                  </v-timeline-item>
                </template>
              </v-timeline>
              <div v-else>
                <center>
                  Sistem belum menerima data dari Ekspedisi, mohon ulangi
                  beberapa saat lagi.
                </center>
              </div>
            </div>
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-row class="text-center">
            <hr />
            <v-btn
              outlined
              @click="(lacakStatusPesanan = false), (selectedItem = null)"
              class="my-2 px-5 text-capitalize"
              >Tutup</v-btn
            >
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import ProfileMenu from "@/components/layout/store/ProfileMenu";
import ModalDelete from "@/components/ModalDelete";
import modalPayment from "@/views/store/profile/ModalPayment";
import moment from "moment";
import ModalNego from "./ModalNego.vue";
import ModalHistoryTermin from "./ModalHistoryTermin.vue";
export default {
  components: {
    ProfileMenu,
    ModalHistoryTermin,
    ModalNego,
    ModalDelete,
    modalPayment,
  },
  data() {
    return {
      nego: false,
      formNego: [],
      lacakStatusPesanan: false,
      selectedItem: null,
      isMobile: false,
    };
  },

  computed: {
    showButtonUploadPayment(){
      // ((detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2') && detailTransaction.is_top !== '1' && detailTransaction.trx_status !== 'paid' ) ||
      // ((detailTransaction.is_top == '1' && detailTransaction.payment_status !== 'paid') && detailTransaction.trx_is_nego !== '1') ||
      // (detailTransaction.is_top == '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2' &&  detailTransaction.payment_status !== 'paid' ) ||
      // (detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_payment_method =='bank_transfer' && detailTransaction.trx_status_nego == '2')||
      //   (detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego !== '1' && detailTransaction.trx_payment_method =='bank_transfer') && detailTransaction.trx_status !== 'paid' ||
      //   (detailTransaction.is_top !== '1' && detailTransaction.trx_is_nego == '1' && detailTransaction.trx_status_nego == '2' )
      const {
        trx_is_nego,
        trx_status_nego,
        is_top,
        trx_status,
        trx_payment_method,
        payment_status
      } = this.detailTransaction
      if(trx_is_nego == '1' && is_top == '1') {
        console.log('is nego & is top')
        if(trx_status_nego == '2' && ( payment_status !== 'paid' || payment_status === null)) return true
      }
      if(trx_is_nego == '1' && is_top == '0' && trx_payment_method == 'bank_transfer') {
        console.log('is nego & is not top')
        if(trx_status_nego == '2' && trx_status == 'created') return true
      }
      if(trx_is_nego == '0' && is_top == '1'){
        console.log('is not nego & is top')
        if(payment_status !== 'paid') return true
        if(payment_status === null) return true
      }
      if(trx_is_nego == '0' && is_top == '0' && trx_payment_method == 'bank_transfer'){
        console.log('is not nego & is not top')
        if(trx_status == 'created') return true
      }
      return false

    },
    ...mapState("transaksiSeller", ["historyTrackingData"]),
    ...mapState("transaction", ["detailTransaction", "loadTransaction"]),
    ...mapState("options", ["bankAccountList"]),
  },
  watch: {
    lacakStatusPesanan: {
      handler: function (val, oldVal) {
        // Log it
        if (val == true) {
          // console.log("detailPes:", this.detailPesanan);
          this.getDetailTracking(
            this.detailTransaction.trx_code,
            this.detailTransaction.trx_agregator,
            this.detailTransaction.order_id_kiriminaja
          );
          this.getDetailHistoryTracking(this.detailTransaction.trx_code);
        }
        console.log("newVal", val, ("oldVal", oldVal));
      },
      deep: true,
    },
  },
  methods: {
    buktiTop() {
      window.open(
        this.$router.resolve({
          name: "tempo-payment",
          query: {
            code: this.detailTransaction.trx_code,
          },
        }).href,
        "_blank"
      );
    },
    statusNego() {
      this.nego = true;
      // this.formNego = this.detailTransaction.trx_detail.filter(x => x.trx_detail_is_nego == '1').map(i => {
      //   const {
      //     trx_detail_product_name:product_name,
      //     trx_detail_id:cart_detail_id,
      //     trx_detail_product_id:cart_detail_product_id,
      //     trx_detail_price:cart_detail_price,
      //     trx_detail_status_nego,
      //     trx_detail_price_nego:cart_detail_price_nego,
      //     trx_detail_product_image
      //   } = i
      //   return {
      //       trx_detail_product_image,
      //       product_name,
      //       cart_detail_id,
      //       status_nego:trx_detail_status_nego,
      //       cart_detail_product_id,
      //       cart_detail_price,
      //       cart_detail_price_nego,
      //   }
      // })

      this.formNego = this.detailTransaction.trx_data_nego.trx_nego_items
        .filter((x) => x.trx_detail_status_nego == "submitted")
        .map((i) => {
          const {
            trx_detail_id,
            trx_detail_product_id,
            trx_detail_product_name,
            trx_detail_price: trx_detail_product_price,
            trx_detail_price_nego,
            trx_detail_nego_is_member,
            trx_detail_nego_is_seller,
            trx_detail_status_nego,
          } = i;
          return {
            trx_detail_id,
            trx_detail_product_id,
            trx_detail_product_name,
            trx_detail_product_price,
            trx_detail_price_nego,
            trx_detail_price_nego_seller: trx_detail_price_nego,
            trx_detail_status_nego:
              trx_detail_nego_is_seller == "1" ? "" : trx_detail_status_nego,
            trx_detail_nego_is_member,
            trx_detail_nego_is_seller,
          };
        });
    },

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },
    statusCaption(status) {
      if (status === "paid") return "Pesanan Baru";
      else if (status === "created") return "Menunggu Pembayaran";
      else if (status === "processed") return "Siap Dikirim";
      else if (status === "on_delivery") return "Dalam Pengiriman";
      else if (status === "completed") return "Pesanan Selesai";
      else if (status === "cancel") return "Dibatalkan";
    },

    colorStatus(status) {
      if (status === "paid") return "green white--text";
      else if (status === "processed") return "blue darken-1 white--text";
      else if (status === "on_delivery")
        return "deep-purple darken-1 white--text";
      else if (status === "completed")
        return "light-green darken-4 white--text";
      else if (status === "cancel") return "red white--text";
    },

    ...mapActions("transaksiSeller", [
      "getHistoryTracking",
      "getTracking",
      "getTrackingKiriminaja",
    ]),
    ...mapActions("transaction", [
      "getTransactionDetail",
      "cancelTransaction",
      "cancelBank",
      "cancelStore",
      "cancelVA",
      "receiveTransaction",
      "uploadConfirmation",
      "uploadCSSumbit",
      "historyUploadTermin",
    ]),
    ...mapActions("options", ["getBankList", "getBankAccountList"]),
    ...mapMutations("transaction", ["clearTransaction"]),
    getDetailHistoryTracking(trxCode) {
      let params = [];
      params = { trx_code: trxCode };
      this.getHistoryTracking(params)
        .then(async () => {
          this.loadingList = false;
        })
        .catch(() => {
          this.loadingList = true;
        });
    },
    async getDetailTracking(trxCode, agregator, oidKiriminaja) {
      let params = [];
      params = { trx_code: trxCode, order_id: oidKiriminaja };
      if (agregator == "kiriminaja") {
        await this.getTrackingKiriminaja(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      } else {
        await this.getTracking(params)
          .then(async () => {
            this.loadingList = false;
          })
          .catch(() => {
            this.loadingList = true;
          });
      }
    },
    getDetail() {
      this.getTransactionDetail({
        invoice: this.$route.params.id,
      }).catch(() => {
        this.$router.push({
          name: "transaction",
        });
      });
    },
    addressText(value) {
      var data = [];
      if (value) {
        if (value.trx_address_detail) data.push(value.trx_address_detail);
        if (value.trx_address_subdistrict_name)
          data.push(value.trx_address_subdistrict_name);
        if (value.trx_address_city_name) data.push(value.trx_address_city_name);
        if (value.trx_address_province_name)
          data.push(value.trx_address_province_name);
      }
      return data.join(", ");
    },
    addressTextStore(value) {
      var data = [];
      if (value) {
        if (value.store_address) data.push(value.store_address);
        if (value.store_subdistrict_name)
          data.push(value.store_subdistrict_name);
        if (value.store_city_name) data.push(value.store_city_name);
        if (value.store_province_name) data.push(value.store_province_name);
      }
      return data.join(", ");
    },
    downloadPDF(pdf) {
      window.open(pdf);
    },
    uploadPayment() {
      let bank = this.bankAccountList.find((el) => {
        return (
          el.bank_account_bank_name ==
            this.detailTransaction.trx_payment_data
              .trx_payment_bank_to_bank_account_bank_name &&
          el.bank_account_number ==
            this.detailTransaction.trx_payment_data
              .trx_payment_bank_to_bank_account_number
        );
      });
      this.$refs.modalPayment.modalShow(
        bank,
        this.detailTransaction.trx_price_grand_total,
        this.detailTransaction.is_top
      );
    },
    confirmTransfer(data) {
      data.append("trx_id", this.detailTransaction.trx_id);
      if (this.detailTransaction.is_top !== "1") {
        this.uploadConfirmation(data).then(() => {
          this.$refs.modalPayment.modalHide();
          this.getDetail();
        });
      } else {
        this.uploadCSSumbit(data).then(() => {
          this.$refs.modalPayment.modalHide();
          this.getDetail();
        });
      }
    },
    cancel() {
      if (this.detailTransaction.trx_payment_method == "midtrans") {
        this.cancelTransaction({
          invoice: this.detailTransaction.trx_midtrans_invoice,
        }).then(() => {
          this.getDetail();
        });
      } else if (this.detailTransaction.trx_payment_method == "bank_transfer") {
        this.cancelBank({
          invoice: this.detailTransaction.trx_midtrans_invoice,
        }).then(() => {
          this.getDetail();
        });
      } else if (this.detailTransaction.trx_payment_method == "payment_store") {
        this.cancelStore({
          invoice: this.detailTransaction.trx_midtrans_invoice,
        }).then(() => {
          this.getDetail();
        });
      } else if (this.detailTransaction.trx_payment_method == "va") {
        this.cancelVA({
          invoice: this.detailTransaction.trx_midtrans_invoice,
        }).then(() => {
          this.getDetail();
        });
      }
    },
    printInvoice(invoice) {
      let routeData = this.$router.resolve({
        name: "invoice",
        params: { id: invoice },
      });
      window.open(routeData.href, "_blank");
    },
    confirmReceived() {
      this.$refs.ModalReceive.modalShow();
    },
    receive() {
      this.receiveTransaction({ trx_id: this.detailTransaction.trx_id }).then(
        () => {
          this.getDetail();
        }
      );
    },
  },
  created() {
    this.$store.dispatch("setPageTitle", "Detail Transaksi");
    this.getBankList();
    this.getBankAccountList();
    this.getDetail();
  },
  beforeDestroy() {
    this.clearTransaction();
  },
};
</script>
